import React from 'react';
import { Box, Button, Container, Typography,Stack, ListItemAvatar, Avatar } from '@mui/material';
import Grid from '@mui/material/Grid';

export const NotFoundPage = () => {
    return (
        // <Box
        //   sx={{
        //     display: 'flex',
        //     justifyContent: 'center',
        //     alignItems: 'center',
        //   }}
        // >
      <Stack padding={3}>
        <Grid container spacing={2}>
          <Grid xs={6}>
            <Typography variant="h1">
              404
            </Typography>
            <Typography variant="h6">
              The page you’re looking for doesn’t exist.
            </Typography>
            <Button variant="contained">Back Home</Button>
          </Grid>
          <Grid xs={6}>
            {/* <img
              src="https://cdn.pixabay.com/photo/2017/03/09/12/31/error-2129569__340.jpg"
              alt=""
              width={500} height={250}
            /> */}
             <Avatar src={'https://cdn.pixabay.com/photo/2017/03/09/12/31/error-2129569__340.jpg'} variant="square" sx={{width: '100%'}}/>
          </Grid>
        </Grid>
      </Stack>
    // </Box>
    )
}